import useGetMyAccountUsersIncludeDeactivated from '@/api/queries/me/useGetMyAccountUsersIncludeDeactivated';
import { UsersInput } from '@/gql/graphql';
import { useMemo } from 'react';

export const useGetMyAccountUsersExcludedDeactivated = (
  userInput?: UsersInput
) => {
  const { data, ...rest } = useGetMyAccountUsersIncludeDeactivated(userInput);

  const activeUsers = useMemo(() => {
    return data ? data.filter((u) => u.status !== 'Deactivated') : [];
  }, [data]);

  return { data: activeUsers, ...rest };
};
